
import {
  WelcomePage
} from 'lib-core'

export { WelcomePage as LandingPage }




export default WelcomePage
